import { IHandleInputChangeProps } from "../interfaces";

export const HandleInputChange = ({
  event, setFormData
}: IHandleInputChangeProps) => {
  const { name, value } = event.target;

  setFormData(prevState => ({
    ...prevState,
    [name]: value
  }))
}
